import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight, Loader2, Check } from "lucide-react";
import { subscribeEmail } from "@/lib/api";

export default function NewsletterForm({ variant = "dark" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeEmail(email);
      setDone(true);
      setEmail("");
      toast.success(res.message || "You're on the list.");
      setTimeout(() => setDone(false), 4000);
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="w-full" data-testid="newsletter-form">
      <div className="flex flex-col gap-3 sm:flex-row">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          aria-label="Email address"
          data-testid="newsletter-email"
          className="h-14 flex-1 rounded-full border border-white/12 bg-rp-card px-6 text-sm text-white placeholder:text-white/35 outline-none transition-colors duration-200 focus:border-rp-accent focus:ring-1 focus:ring-rp-accent"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="newsletter-submit"
          className="group inline-flex h-14 items-center justify-center gap-2 rounded-full bg-rp-accent px-8 font-mono text-xs font-semibold uppercase tracking-[0.14em] text-black transition-colors duration-200 hover:bg-white disabled:opacity-70"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : done ? <Check className="h-4 w-4" /> : null}
          {done ? "Joined" : "Join Our List"}
          {!loading && !done && <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />}
        </button>
      </div>
      <p className="mt-3 font-mono text-[11px] tracking-wide text-white/35">
        No spam. Updates on our journey and future locations. Unsubscribe anytime.
      </p>
    </form>
  );
}
